import QmRefresh from './src/main'

/* istanbul ignore next */
QmRefresh.install = function (Vue) {
  Vue.component(QmRefresh.name, QmRefresh)
}

export default QmRefresh
